import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TypesUtilsService } from 'src/app/core/_base/crud';
import { AcDetailTransactionRating } from 'src/app/core/asset_class/_models/asset-class-detail.model';

type PropertyRatingData = Pick<AcDetailTransactionRating,
  'assessment_date' | 'land_value' | 'improvements_value' | 'chattels_value' | 'rating_comment'>

@Component({
  selector: 'kt-inspection-property-rating',
  templateUrl: './inspection-property-rating.component.html',
  styleUrls: ['./inspection-property-rating.component.scss']
})
export class InspectionPropertyRatingComponent implements OnInit {
  @Input() currency: string;
  @Input() ratingData: PropertyRatingData;
  components = [
    { key: 'land_value', label: 'Land' },
    { key: 'improvements_value', label: 'Improvements' },
    { key: 'chattels_value', label: 'Chattels' },
  ]
  displayedColumns = ['component', 'value'];
  form: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private typesUtilsService: TypesUtilsService
  ) { }

  ngOnInit(): void {
    const data = this.ratingData;
    this.form = this.formBuilder.group({
      assessment_date: [data ? data.assessment_date : null],
      land_value: [data ? data.land_value : null],
      improvements_value: [data ? data.improvements_value : null],
      chattels_value: [data ? data.chattels_value : null],
      rating_comment: [data ? data.rating_comment : null],
    });
  }

  get capitalValue(): number {
    return this.components.reduce((total, item) => {
      const value = Number(this.form.controls[item.key].value);
      return total + (isNaN(value) ? 0 : value);
    }, 0);
  }

  clearDate(ctrl: AbstractControl) {
    ctrl.setValue(null);
    ctrl.updateValueAndValidity();
  }

  getData(): PropertyRatingData {
    const controls = this.form.controls;
    return {
      assessment_date: controls.assessment_date.value
        ? this.typesUtilsService.getDateStringFromDate(new Date(controls.assessment_date.value))
        : null,
      land_value: toNumber(controls.land_value.value),
      improvements_value: toNumber(controls.improvements_value.value),
      chattels_value: toNumber(controls.chattels_value.value),
      rating_comment: controls.rating_comment.value,
    };
  }
}

function toNumber(value: any): number {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const num = Number(value);
  return isNaN(num) ? null : num;
}
